<template lang="pug">
    div(:class="'context-'+context")
        include HomeBoxes.pug
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'HomeBoxes',
    computed: mapState([
        "context",
    ]),
    data() {
        // Data contained on the component
        return {
        };
    }
}

</script>

<style scoped lang="scss">
@import "./../../variables";
@import "./../../variables_colreps";

@import "HomeBoxes";

.context-colreps {
    @import "HomeBoxesColreps";
}
</style>



// WEBPACK FOOTER //
// src/components/home_boxes/HomeBoxes.vue